import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { WeatherRemarkEditPage } from './weather-remark-edit';
import { DirectivesModule } from '../../../directives/directives.module';

@NgModule({
  declarations: [
    WeatherRemarkEditPage,
  ],
  imports: [
    IonicPageModule.forChild(WeatherRemarkEditPage),
    DirectivesModule,
  ],
})
export class WeatherRemarkEditPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/weather-readings/weather-remark-edit/weather-remark-edit.module.ts